import { useRef, useState } from "react";
import { Upload, Loader2, Images, Pencil, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function UploadButton({ onUploaded, testid }) {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const [gopen, setGopen] = useState(false);
  const [files, setFiles] = useState([]);

  const openGallery = async () => {
    try { const { data } = await api.get("/files"); setFiles(data); setGopen(true); }
    catch { toast.error("Impossibile aprire la galleria"); }
  };
  const pick = (url) => { onUploaded(url); setGopen(false); };
  const rename = async (f) => {
    const label = window.prompt("Nome immagine:", f.label || "");
    if (label == null) return;
    try { await api.put("/files/rename", { path: f.path, label }); const { data } = await api.get("/files"); setFiles(data); toast.success("Rinominata"); }
    catch { toast.error("Errore"); }
  };
  const del = async (f) => {
    if (!window.confirm("Eliminare questa immagine dalla galleria?")) return;
    try { await api.delete("/files", { data: { path: f.path } }); const { data } = await api.get("/files"); setFiles(data); toast.success("Eliminata"); }
    catch { toast.error("Errore"); }
  };

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.url);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload non riuscito");
    }
    setLoading(false);
    e.target.value = "";
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onChange} data-testid={testid ? `${testid}-input` : undefined} />
      <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={loading} data-testid={testid} className="rounded-full border-stone-300 shrink-0" title="Carica immagine">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
      </Button>
      <Button type="button" variant="outline" onClick={openGallery} data-testid={testid ? `${testid}-gallery` : undefined} className="rounded-full border-stone-300 shrink-0" title="Galleria immagini">
        <Images className="w-4 h-4" />
      </Button>
      <Dialog open={gopen} onOpenChange={setGopen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-serif text-xl">Galleria immagini</DialogTitle></DialogHeader>
          {files.length === 0 ? <p className="text-sm text-stone-400 py-6 text-center">Nessuna immagine caricata finora</p> : (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {files.map((f) => (
                <div key={f.path} className="space-y-1">
                  <button type="button" onClick={() => pick(f.url)} data-testid="gallery-item"
                          className="aspect-square w-full rounded-lg overflow-hidden border border-stone-200 hover:ring-2 hover:ring-[#0F4C81] transition">
                    <img src={f.url} alt={f.label || ""} className="w-full h-full object-cover" />
                  </button>
                  <div className="flex items-center gap-1">
                    <span className="text-[10px] text-stone-500 truncate flex-1">{f.label}</span>
                    <button type="button" onClick={() => rename(f)} data-testid="gallery-rename" className="text-stone-400 hover:text-[#0F4C81]"><Pencil className="w-3 h-3" /></button>
                    <button type="button" onClick={() => del(f)} data-testid="gallery-delete" className="text-stone-400 hover:text-red-500"><Trash2 className="w-3 h-3" /></button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
